import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, vModelText as _vModelText, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header d-flex flex-row justify-content-between" }
const _hoisted_3 = { class: "btn-toolbar" }
const _hoisted_4 = {
  key: 0,
  class: "form-check form-switch"
}
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 0,
  class: "text-center text-muted small py-2"
}
const _hoisted_7 = {
  class: "btn-group btn-group-sm w-100 mb-2",
  role: "group"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_13 = { class: "mb-2" }
const _hoisted_14 = {
  class: "form-label small mb-1",
  for: "cmmi-note"
}
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = ["placeholder", "disabled"]
const _hoisted_17 = { class: "d-flex justify-content-center" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("span", null, [
        _createElementVNode("i", { class: "fas fa-fire fa-fw me-1" }),
        _createTextVNode("Activar Acelerador de Riqueza ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.hasCmmi)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input secondary",
                type: "checkbox",
                role: "switch",
                id: "enable-cmmi",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enabled) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.enabled]
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.hasCmmi)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("i", { class: "fas fa-circle-info fa-fw me-1" }, null, -1),
            _createTextVNode("Este usuario ya cuenta con el Acelerador de Riqueza activo. ", -1)
          ]))]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-muted small mb-2" }, [
              _createTextVNode(" Solo "),
              _createElementVNode("strong", null, "posiciona"),
              _createTextVNode(" al usuario en la red del Acelerador de Riqueza — "),
              _createElementVNode("strong", null, "no genera comisión"),
              _createTextVNode(". Si excepcionalmente hiciera falta una, se agrega a mano con \"Agregar Comisión\". ")
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                class: "btn-check",
                id: "origin-transfer",
                value: "transfer",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.origin) = $event)),
                disabled: !_ctx.enabled
              }, null, 8, _hoisted_8), [
                [_vModelRadio, _ctx.origin]
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("label", {
                class: "btn btn-outline-secondary",
                for: "origin-transfer"
              }, " Transferencia ", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                class: "btn-check",
                id: "origin-grant",
                value: "grant",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.origin) = $event)),
                disabled: !_ctx.enabled
              }, null, 8, _hoisted_9), [
                [_vModelRadio, _ctx.origin]
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("label", {
                class: "btn btn-outline-secondary",
                for: "origin-grant"
              }, " Cortesía ", -1))
            ]),
            (_ctx.origin === 'transfer')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", {
                    class: "form-label small mb-1",
                    for: "cmmi-source"
                  }, " Cuenta de origen (la que ya tenía el Acelerador) ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    id: "cmmi-source",
                    type: "text",
                    class: "form-control form-control-sm",
                    placeholder: "usuario anterior",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.transferredFrom) = $event)),
                    disabled: !_ctx.enabled
                  }, null, 8, _hoisted_11), [
                    [
                      _vModelText,
                      _ctx.transferredFrom,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _cache[11] || (_cache[11] = _createElementVNode("div", { class: "form-text" }, [
                    _createTextVNode(" Se le "),
                    _createElementVNode("strong", null, "revoca"),
                    _createTextVNode(" el Acelerador y queda registrada la liga. Su nodo viejo se queda en la estructura. ")
                  ], -1))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("div", { class: "form-text mb-2" }, " VIP de cortesía / premio: nadie pagó y no viene de nadie. ", -1)
                ]))])),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, [
                _cache[13] || (_cache[13] = _createTextVNode(" Nota ", -1)),
                (_ctx.origin === 'grant')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, "*"))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createElementVNode("textarea", {
                id: "cmmi-note",
                class: "form-control form-control-sm",
                rows: "2",
                placeholder: 
              _ctx.origin === 'grant'
                ? 'Obligatoria: por qué se otorga este VIP'
                : 'Opcional'
            ,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.note) = $event)),
                disabled: !_ctx.enabled
              }, null, 8, _hoisted_16), [
                [
                  _vModelText,
                  _ctx.note,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                class: "btn btn-outline-warning btn-sm",
                disabled: !_ctx.canSubmit,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activate()))
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-check fa-fw me-1" }, null, -1)),
                _cache[15] || (_cache[15] = _createTextVNode("Activar Acelerador ", -1)),
                (_ctx.activating)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_18)
            ])
          ], 64))
    ])
  ]))
}